export const isTouchDevice = (): boolean => {
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    'ontouchstart' in window || navigator.maxTouchPoints > 0 || (navigator.msMaxTouchPoints as number) > 0
  );
};
